
import Auth from "../../../components/auth/auth";
export function auth(state = new Auth(), action) {
    switch(action.type) {
      default:
        return state;
    }
  }